import { PAGE_TEXT as NOMINATION_PAGE_TEXT } from '../../../../../Nomination/components/lang';
export const submitted = `
<p>You have updated the“Meeting Condition(s)" section. The programme offering department will review your supporting documents and
confirm your status. You can login the system to check your conditional offer status 3 days after meeting condition(s).</p>
<p>For queries on the conditional offer status, please contact Mr. Gary SHAM at 3400 8582 / <a>gary-ky.sham@polyu.edu.hk</a>.</p>
`;

export const CONDITION_STATUS_TEXT = {
  CREATED: 'Pending for Meeting Condition(s)',
  PENDING: 'Submitted Supporting Document(s)',
  APPROVED: 'Meet',
  REJECTED: 'Not Meet',
  MODIFICATION_REQUIRED: 'Pending for Meeting Condition(s)',
  PASSED_DEADLINE: 'Passed Deadline',
};

export const CONDITION_MEET_TEXT = {
  SUBMIT_STEPS: [
    `Please complete the Meeting Conditions procedures by clicking the <span style="color:#951d1d">GO TO UPDATE</span> button, which will be available 30 days prior to your Meet Condition Date. <span style="color:#951d1d">Make sure to return to this page and submit this “Meet Condition” form by clicking <b>SUBMIT</b> at the bottom.</span>`,
    `Even if you have arranged to send us documents for verification, you must complete this step to proceed with Online Registration.`,
    `Once your "Meeting Condition Status" has turned to "Confirmed", you can log in to the system to check your conditional offer status.`,
  ],
  CONDITION_CHECK_RESULT: 'Condition Check Result',
  GO_TO_UPDATE: 'Go to Update',
  YOU_HAVE_SUBMITTED:
    'You have submitted your meeting condition proof files, please wait for the condition check result. ',
  YOU_HAVE_MET: 'You have met the condition(s).',
  CONDITION_REJECTED: 'Your condition(s) have been rejected.',
  CONDITION_CANCELED: 'Your condition(s) have been canceled.',
  PASSED_DEADLINE: 'You have met the deadline for the meeting conditions.',
};

const GSB_TEXT = NOMINATION_PAGE_TEXT.GSB1_FORM;
const {
  ENTRANCE_REQUIREMENT_TYPE,
  LANGUAGE_REQUIREMENT_TYPE,
  NOT_MEET_REQUIREMENT,
} = GSB_TEXT;
export const conditionRequirementMap: Record<string, string> = {
  [ENTRANCE_REQUIREMENT_TYPE.SECOND_CLASS_BACHELOR]: `A Bachelor's degree with Second Class Honours or above`,
  [ENTRANCE_REQUIREMENT_TYPE.EQUAL_SECOND_CLASS_BACHELOR]: `A Bachelor's degree equivalent to Second Class Honours or above`,
  [ENTRANCE_REQUIREMENT_TYPE.MPHIL]: `A MPhil's degree`,
  [ENTRANCE_REQUIREMENT_TYPE.DISSERTATION_MASTER]: `A Master's degree with a dissertation as an award requirement`,
  [ENTRANCE_REQUIREMENT_TYPE.FIRST_CLASS_BACHELOR]: `A Bachelor's degree with First Class Honours`,
  [ENTRANCE_REQUIREMENT_TYPE.EQUAL_FIRST_CLASS_BACHELOR]: `A Bachelor's degree equivalent to First Class Honours`,
  [ENTRANCE_REQUIREMENT_TYPE.MASTER]: `A Master's degree`,

  [LANGUAGE_REQUIREMENT_TYPE.ENGLISH_TEST_RESULT]: `Valid English test results`,
  [LANGUAGE_REQUIREMENT_TYPE.LANGUEGE_PROOF]: `A degree for which English was the language of instruction with proof`,
  [NOT_MEET_REQUIREMENT]: `Not meet any requirements`,
};

export const PAGE_TEXT = {
  NO_ACTION_REQUIRED: 'No Action Required',
  YOU_DO_NOT_NEED_TO_MEET_ANY_CONDITION:
    'You do not need to meet any condition.',
  MEET: 'Meet',
  NOT_MEET: 'Not Meet',
  MEETING_CONDITION_REMARKS: 'Remarks (if any)',
  NA: 'N/A',
  OTHER_TEST_REQUIREMENT: 'Other Test Requirement',
};
